module.exports = __webpack_public_path__ + "why4.png?eaad99b08028d367fe4bfed255812147";